import { makeStyles } from '@material-ui/core/styles';
import { mergeStyles } from './stylesSelector';
import { cloneDeep } from 'lodash';
import { CONTENT_MIN_WIDTH, styleBreakDesktop, styleBreakMobile, styleBreakSmallMobile } from '../components/utilities/layouts/Globals';

// This function will merge custom overrides.
export const FullScreenButtonPageStyle = stylesOverride => {
    return makeStyles(theme => {
        const defaultstyles = {
            root: {
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-around',
                [styleBreakMobile(theme)]: {
                    paddingTop: theme.spacing(4),
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                },
            },
            button: {
                width: 'fit-content',
                minWidth: theme.spacing(35),
                marginTop: theme.spacing(5),
                [styleBreakMobile(theme)]: {
                    position: 'fixed',
                    marginBottom: theme.spacing(3),
                    marginTop: theme.spacing(0),
                    bottom: '0',
                    minWidth: CONTENT_MIN_WIDTH,
                    width: 'calc(100% - 48px)',
                    left: '50%',
                    transform: 'translateX(-50%)',
                },
            },
            loadingButton: {
                backgroundColor: theme.palette.primary.dark,
                '&:disabled': {
                    backgroundColor: theme.palette.primary.dark,
                },
            },
            loadingIcon: {
                color: theme.palette.primary.contrastText,
            },
            subtitle: {
                marginTop: theme.spacing(4),
                textAlign: 'center',
                maxWidth: '303px',
            },
            body: {
                maxWidth: '378px',
                [styleBreakMobile(theme)]: {
                    marginTop: theme.spacing(2.5),
                    marginBottom: theme.spacing(6),
                    maxWidth: '325px',
                    textAlign: 'center',
                },
            },
            bodyText: {
                marginTop: theme.spacing(2),
                [styleBreakMobile(theme)]: {
                    marginTop: theme.spacing(1.5),
                    maxWidth: '350px',
                },
            },
            contentLayoutDiv: {
                height: 'calc(100vh - 85px)',
                width: '100%',
                [styleBreakMobile(theme)]: {
                    height: 'calc(100vh - 64px)',
                },
                [styleBreakDesktop(theme)]: {
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                },
            },
            icon: {
                width: '280px',
                height: '280px',
                [styleBreakMobile(theme)]: {
                    width: '200px',
                    height: '200px',
                },
            },
            shadowedIcon: {
                // marginTop: -theme.spacing(5),
                [styleBreakMobile(theme)]: {
                    alignItems: 'center',
                    marginTop: theme.spacing(1) + 1,
                    marginBottom: 0,
                },
            },
            shadow: {
                marginTop: -(theme.spacing(1) + 2),
                [styleBreakMobile(theme)]: {
                    marginTop: -theme.spacing(3),
                },
            },
            fullscreenButtonPageHorizontalPaddingOverride: {
                paddingLeft: 0,
                paddingRight: 0,
                [styleBreakSmallMobile(theme)]: {
                    minWidth: CONTENT_MIN_WIDTH - theme.spacing(6),
                },
            },
        };

        // overrides the default
        return mergeStyles(cloneDeep(defaultstyles), stylesOverride || {});
    });
};

export const FullScreenInputButtonPageStyle = stylesOverride => {
    return makeStyles(theme => {
        const defaultstyles = {
            root: {
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-around',
                [styleBreakMobile(theme)]: {
                    paddingTop: theme.spacing(4),
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                },
            },
            button: {
                width: 'fit-content',
                minWidth: theme.spacing(35),
                marginTop: theme.spacing(5),
                [styleBreakMobile(theme)]: {
                    position: 'fixed',
                    marginBottom: theme.spacing(3),
                    marginTop: theme.spacing(0),
                    bottom: '0',
                    minWidth: CONTENT_MIN_WIDTH,
                    width: 'calc(100% - 48px)',
                    left: '50%',
                    transform: 'translateX(-50%)',
                },
            },
            loadingButton: {
                backgroundColor: theme.palette.primary.dark,
                '&:disabled': {
                    backgroundColor: theme.palette.primary.dark,
                },
            },
            loadingIcon: {
                color: theme.palette.primary.contrastText,
            },
            subtitle: {
                marginTop: theme.spacing(4),
                textAlign: 'center',
                maxWidth: '303px',
            },
            body: {
                maxWidth: '378px',
                [styleBreakMobile(theme)]: {
                    marginTop: theme.spacing(2.5),
                    marginBottom: theme.spacing(6),
                    maxWidth: '325px',
                    textAlign: 'left',
                    '& p.MuiTypography-body1': {
                        textAlign: 'left',
                    },
                },
            },
            bodyText: {
                marginTop: theme.spacing(2),
                [styleBreakMobile(theme)]: {
                    marginTop: theme.spacing(1.5),
                    maxWidth: '350px',
                },
            },
            contentLayoutDiv: {
                height: 'calc(100vh - 85px)',
                width: '100%',
                [styleBreakMobile(theme)]: {
                    height: 'calc(100vh - 64px)',
                },
                [styleBreakDesktop(theme)]: {
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                },
            },
            icon: {
                width: '280px',
                height: '280px',
                [styleBreakMobile(theme)]: {
                    width: '104px',
                    height: '104px',
                },
            },
            shadowedIcon: {
                // marginTop: -theme.spacing(5),
                [styleBreakMobile(theme)]: {
                    alignItems: 'center',
                    marginTop: theme.spacing(1) + 1,
                    marginBottom: 0,
                    marginLeft: theme.spacing(-30),
                },
            },
            shadow: {
                marginTop: -(theme.spacing(1) + 2),
                [styleBreakMobile(theme)]: {
                    marginTop: -theme.spacing(2),
                    width: '104px',
                    height: '40px',
                },
            },
            fullscreenButtonPageHorizontalPaddingOverride: {
                paddingLeft: 0,
                paddingRight: 0,
                [styleBreakSmallMobile(theme)]: {
                    minWidth: CONTENT_MIN_WIDTH - theme.spacing(6),
                },
            },
        };

        // overrides the default
        return mergeStyles(cloneDeep(defaultstyles), stylesOverride || {});
    });
};